import { mediaMax } from "components/designV2/breakpoints";
import { Radius, Spacing } from "components/designV2/constants";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";
import { SettingsV2PageTitle } from "../companySettingsV2.styled";

export const CompanyUsersHeader = styled.div`
  align-items: center;
  display: flex;
  gap: ${Spacing.md}px;
  justify-content: space-between;
  margin-bottom: ${Spacing.xl}px;

  ${mediaMax.mobile} {
    align-items: flex-start;
    flex-direction: column;
  }
`;

export const CompanyUsersTitle = styled(SettingsV2PageTitle)``;

export const AddUserButtonSlot = styled.div`
  flex-shrink: 0;
`;

export const CompanyUsersList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const UserRow = styled.div`
  align-items: center;
  background: ${ColorV2.Blue7};
  border: 1px solid transparent;
  border-radius: ${Radius.xl}px;
  column-gap: 12px;
  display: grid;
  grid-template-columns:
    minmax(240px, 1.5fr) minmax(220px, 1.4fr) minmax(160px, 0.8fr)
    88px;
  padding: 12px 16px;
  width: 100%;

  ${mediaMax.desktop} {
    grid-template-columns:
      minmax(220px, 1.4fr) minmax(200px, 1.3fr) minmax(140px, 0.8fr)
      80px;
  }

  ${mediaMax.tablet} {
    align-items: flex-start;
    grid-template-columns: 1fr auto;
    row-gap: ${Spacing.sm}px;
  }
`;

export const EmailCell = styled.div`
  min-width: 0;

  ${mediaMax.tablet} {
    grid-column: 1 / -1;
    padding-left: 60px;
  }
`;

export const UserTypeCell = styled.div`
  min-width: 0;

  ${mediaMax.tablet} {
    grid-column: 1;
    padding-left: 60px;
  }
`;

export const UserActionsCell = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  min-height: 40px;
`;

export const ActionButtons = styled.div`
  align-items: center;
  display: inline-flex;
  gap: ${Spacing.sm}px;
  justify-content: flex-end;
`;

export const IconButton = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  display: inline-flex;
  height: 30px;
  justify-content: center;
  padding: 0;
  width: 30px;

  &:hover {
    opacity: 0.72;
  }

  &:focus-visible {
    outline: 2px solid ${ColorV2.Blue1};
    outline-offset: 2px;
  }
`;

export const ListMessage = styled.div`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue4};
  padding: ${Spacing.md}px 4px;
`;

export const LoadingContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 120px;

  &::after {
    animation: companyUsersSpin 0.8s linear infinite;
    border: 3px solid ${ColorV2.Blue6};
    border-radius: 999px;
    border-top-color: ${ColorV2.Blue1};
    content: "";
    height: 24px;
    width: 24px;
  }

  @keyframes companyUsersSpin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const CompanyUserFormFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.md}px;
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${Spacing.md}px ${Spacing.lg}px;
  min-width: 0;
  padding: ${Spacing.sm}px 0;
`;

export const RadioOption = styled.label`
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  gap: ${Spacing.sm}px;
`;

export const HiddenRadio = styled.input`
  opacity: 0;
  position: absolute;
  pointer-events: none;
`;

export const RadioControl = styled.span`
  border: 2px solid ${ColorV2.Blue4};
  border-radius: 999px;
  display: inline-flex;
  flex-shrink: 0;
  height: 24px;
  position: relative;
  width: 24px;

  ${RadioOption} ${HiddenRadio}:checked + & {
    border-color: ${ColorV2.Blue1};
  }

  ${RadioOption} ${HiddenRadio}:checked + &::after {
    background: ${ColorV2.Blue1};
    border-radius: 999px;
    content: "";
    height: 12px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
  }

  ${RadioOption} ${HiddenRadio}:focus-visible + & {
    outline: 2px solid ${ColorV2.Blue1};
    outline-offset: 3px;
  }
`;

export const RadioLabel = styled.span`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue1};
`;

export const ModalActions = styled.div`
  align-items: center;
  display: flex;
  gap: ${Spacing.sm}px;
  justify-content: flex-end;

  ${mediaMax.mobile} {
    align-items: stretch;
    flex-direction: column;
  }
`;

export const CompanyUserFormActions = styled.div`
  display: flex;
  gap: ${Spacing.sm}px;
  justify-content: center;
  padding-top: ${Spacing.sm}px;

  ${mediaMax.mobile} {
    align-items: stretch;
    flex-direction: column-reverse;
  }
`;
